import { createContext } from "react";
import { GeneralObject } from "../../definitions/general";

type SeedContextInterface = {
  crsSeed: GeneralObject | null;
  geetaSeed: GeneralObject | null;
  profileSeed: GeneralObject | null;
  supplySeed: GeneralObject | null;
  chatSeed: GeneralObject | null;
  discoverSeed: GeneralObject | null;
  bookingSeed: GeneralObject | null;
};

const SeedContext = createContext<SeedContextInterface>({
  crsSeed: null,
  geetaSeed: null,
  profileSeed: null,
  supplySeed: null,
  chatSeed: null,
  discoverSeed: null,
  bookingSeed: null,
});

export default SeedContext;
